import {DashboardComponentState} from "../components/pages/dashboard/components/interfaces";

declare global {
    interface Window {
        dashboardComponentStates: Record<string, DashboardComponentState>
        dashboardState: "loading" | "finished" | "error"
    }
}

const getComponentStates = () => {
    if (!window.dashboardComponentStates) {
        window.dashboardComponentStates = {}
    }

    return window.dashboardComponentStates
}

export const storeDashboardComponentState = (state: DashboardComponentState) => {
    const states = getComponentStates()

    states[state.id] = state
}

export const getDashboardComponentState = (id: string) => {
    const states = getComponentStates()

    return states[id]
}

export const getFinishedDashboardComponents = (ids: string[]) => {
    return ids.filter(id => {
        const state = getDashboardComponentState(id);
        return state?.state === "finished";
    }).length
}

export const setDashboardState = (state: "loading" | "finished" | "error") => {
    window.dashboardState = state
}

export const getDashboardState = () => {
    return window.dashboardState || "loading"
}